import { render, staticRenderFns } from "./PreStoreForm.vue?vue&type=template&id=618c0688&scoped=true&"
import script from "./PreStoreForm.vue?vue&type=script&lang=js&"
export * from "./PreStoreForm.vue?vue&type=script&lang=js&"
import style0 from "./PreStoreForm.vue?vue&type=style&index=0&id=618c0688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c0688",
  null
  
)

export default component.exports